import { useIntl as useIntlFromNav } from "@platform/cj-platform-navigation";
import { useNav2022 } from "hooks";
import intl from "utils/intl";

export const useIntl = () => {
  const { nav2022 } = useNav2022();
  return (nav2022 ? useIntlFromNav : () => intl)();
};
